import { isHTMLElement } from '../is-html-element';

export function getParentsOrSelf(element: HTMLElement): HTMLElement[] {
	const parents: HTMLElement[] = [];

	if (element && isHTMLElement(element)) {
		parents.push(element);

		if (element.parentElement) {
			parents.push(...getParentsOrSelf(element.parentElement));
		}
	}

	return parents;
}
